'use client';

import { Button, Separator } from '@baseball-near-you/ui';
import { ClaimCard } from '@bb/components/Settings/Team/ClaimTeam/ClaimCard';
import { useUserProfile } from '@bb/lib/hooks/useUserProfile';
import { ChevronRightCircle } from 'lucide-react';
import { useState } from 'react';
import { TeamSelectionModal } from '../../Settings/Team/ClaimTeam/TeamSelectionModal';
import type { OnboardingStep } from './types';

export function TeamStep(props: {
  setCurrentStep: (step: OnboardingStep) => void;
  onStepSuccess: () => Promise<void>;
}) {
  const { userProfile } = useUserProfile();
  const [onboardingCompleting, setOnboardingCompleting] = useState(false);
  return (
    <div className="flex w-full max-w-4xl flex-col">
      <TeamSelectionModal onSuccess={props.onStepSuccess} />
      {!!userProfile?.claims.length && (
        <>
          <Separator className="my-4" />
          <h2 className="mb-2 text-xl">Previous claims</h2>
          <div className="flex h-72 flex-col space-y-3 overflow-auto border-b border-b-gray-300 pb-3 shadow-xs md:h-96">
            {userProfile?.claims.map((claim) => (
              <ClaimCard claim={claim} key={claim.id} />
            ))}
          </div>
          <Button
            loading={onboardingCompleting}
            onClick={async () => {
              setOnboardingCompleting(true);
              await props.onStepSuccess();
            }}
            className="mt-4 self-end"
          >
            Continue <ChevronRightCircle className="ml-2" size={18} />
          </Button>
        </>
      )}
    </div>
  );
}
